module.exports = __webpack_public_path__ + "img/preview.bd1f68c2.png";